import React from "react";
import {Route} from "react-router-dom";
import routes from "../routes.js";
import '../i18n';
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";
import {MdMenu} from 'react-icons/md';

const whoIsItFor = [{name: "Yoga studios", icon: require("assets/img/icons/landing/yoga.svg").default},
    {name: "Gyms", icon: require("assets/img/icons/landing/workout.svg").default},
    {name: "Dance schools", icon: require("assets/img/icons/landing/dance.svg").default},
    {name: "Martial Arts schools", icon: require("assets/img/icons/landing/boxing.svg").default},
    {name: "Teams", icon: require("assets/img/icons/landing/team.svg").default},
    {name: "Pilates instructors", icon: require("assets/img/icons/landing/exercise.svg").default},
    {name: "Private teachers", icon: require("assets/img/icons/landing/basketball-player.svg").default},
]

class Landing extends React.Component {

    constructor(props) {
        super(props);
        this.mainRef = React.createRef();
    }

    componentDidUpdate(e) {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.mainRef.current.scrollTop = 0;
    }

    render() {
        return (
            <>
                <div className="main-content" ref={this.mainRef} style={{fontFamily: 'Montserrat'}}>
                    <Row style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <Col className="my-4" lg="8" sm="10">
                            <div style={{
                                display: "flex",
                                flexFlow: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderRadius: 50,
                                padding: 20
                            }}>
                                <label className="h1 text-black m-0">OPEN</label>
                                <MdMenu color="gray" size={30}/>
                            </div>

                            <div className="text-center text-black my-2">
                                <label style={{marginTop: 30, color: "black", fontWeight: 900, fontSize: "1.4rem"}}>World simplest platform for bookings and fitness center management.</label>
                            </div>

                            {/*WHO IS IT FOR */}
                            <div className="text-center mt-6">
                                <label style={{fontWeight: 600, fontSize: "1.3rem"}}>Who is it for</label>
                            </div>

                            <div style={{
                                display: "flex",
                                flexFlow: "row",
                                flexWrap: "wrap",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                {whoIsItFor.map((item, index) => {
                                    return (
                                        <div style={{
                                            width: '25%',
                                            height: 150,
                                            borderRadius: 30,
                                            // backgroundColor: "#f8f7f5",
                                            boxShadow: "2px 2px 4px rgba(0,0,0,.2)",
                                            display: "flex",
                                            margin: 10,
                                            flexFlow: "column",
                                            flexWrap: "none",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: 20
                                        }}>
                                            <img
                                                alt="..."
                                                width={64}
                                                style={{marginBottom: 10}}
                                                src={item.icon}/>
                                            <div className="text-center">{item.name}</div>
                                        </div>
                                    )
                                })}

                            </div>

                            {/*WHAT CAN IT DO*/}

                            <div className="text-center mt-4">
                                <label style={{marginTop: 40, fontWeight: 600, fontSize: "1.3rem"}}>What can it do</label>
                            </div>


                            <div style={{
                                display: "flex",
                                flexFlow: "row",
                                flexWrap: "wrap",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                {whoIsItFor.map((item, index) => {
                                    return (
                                        <div key={`tr-${index}`} style={{
                                            width: 142,
                                            height: 142,
                                            borderRadius: 30,
                                            backgroundColor: "#f8f6f3",
                                            display: "flex",
                                            margin: 10,
                                            flexFlow: "column",
                                            flexWrap: "none",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: 20
                                        }}>
                                            <img
                                                alt="..."
                                                width={64}
                                                style={{marginBottom: 10}}
                                                src={item.icon}/>
                                            <div className="text-center">{item.name}</div>
                                        </div>
                                    )
                                })}

                            </div>


                        </Col>
                    </Row>
                    {/*<Container fluid>*/}
                    {/*    <AdminFooter/>*/}
                    {/*</Container>*/}
                </div>
            </>
        );
    }
}

export default Landing;
